module.exports = __webpack_public_path__ + "img/10s-ago.24c04301.svg";